import { useState } from "react";
import { toast } from "react-toastify";
import * as constants from "../../constants/fixture.constants";
import { fixturesService } from "../../services/fixtures.service";

export interface UseSetOptaId {
    setOptaId: (fixtureId: string, optaId: string, onSuccess?: () => void) => void;
    loading: boolean;
    success: boolean;
    error: any;
}

const useSetOptaId = (): UseSetOptaId => {
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const setOptaId = (fixtureId: string, optaId: string, onSuccess?: () => void) => {
        const set = async () => {
            setLoading(true);
            setError(false);
            setSuccess(false);

            try {
                await fixturesService.setOptaId(fixtureId, optaId);
                setSuccess(true);
                toast.success(optaId === "" ? constants.OPTA_ID_SUCCESSFULLY_CLEARED : constants.OPTA_ID_SUCCESSFULLY_SET);
                if (onSuccess) onSuccess();
            } catch (error: any) {
                setError(error);
                toast.error(error?.data?.errors?.[0] || constants.OPTA_ID_FAILED);
            }
            setLoading(false);
        };

        set();
    };

    return { setOptaId, success, loading, error };
};

export default useSetOptaId;
